/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchStatus = {
  Active: "active",
  Scheduled: "scheduled",
  Expired: "expired",
  Lifted: "lifted",
} as const;
export type KillswitchStatus = ClosedEnum<typeof KillswitchStatus>;

/** @internal */
export const KillswitchStatus$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchStatus
> = z.enum(KillswitchStatus);
